<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            v-model="modalPay.show"
            @hidden="closeModal()"
        >
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-12">
                        <span class="close cursor-pointer" @click="modalPay.show = false">&times;</span>
                    </div>
                </div>
                <div class="row text-center">
                    <div class="col-12">
                        <h3>ข้อมูลการชำระเงิน</h3>
                    </div>
                    <div class="col-12">
                        <div class="h2 font-weight-bold">
                            <span v-if="modalPay.type == 'FULL'">
                                {{ ( (checkWalletAvailableBalance) ? (modalPay.invoice.total - $WALLET.available_balance) : modalPay.invoice.total ) | numFormat('0,0.00')}}
                            </span>
                            <span v-else-if="modalPay.type == 'VAT_WHT'">
                                {{ ( (checkWalletAvailableBalance) ? (modalPay.invoice.total_net_price - $WALLET.available_balance) : modalPay.invoice.total_net_price)| numFormat('0,0.00')}}</span>
                            <span v-else>{{0 | numFormat('0,0.00')}}</span>
                            <span class="h5"> บาท</span>
                            <h5 class="text-muted" v-if="!this.$USER_LOGIN.get().isShippop">วันครบกำหนดชำระ {{modalPay.invoice.due_date | dateFormat }}</h5>
                        </div>
                    </div>
                    <div class="col-12">
                        <b-form-group>
                            <b-form-radio-group v-model="modalPay.type">
                                <b-form-radio v-for="pay in typePay" :key="pay.key" :value="pay.key">
                                    <span v-if="pay.key == 'VAT_WHT'" v-b-tooltip title="นิติบุคคลหักภาษี ณ ที่จ่าย จากค่าขนส่ง 1% และค่าบริการ 3%">{{pay.name}}</span>
                                    <span v-else>{{pay.name}}</span>
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <div class="col-12" v-if="this.$USER_LOGIN.get().isShippop">
                        <div class="row justify-content-center text-left">
                            <div class="col-10">
                                <div class="form-group">
                                    <label>
                                        เลือกวันที่ชำระเงิน
                                    </label>
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        placeholder="วันที่ชำระเงิน"
                                        v-model="modalPay.datePaid"
                                        :max="maxDate"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pt-4">
                        <template v-if="this.$USER_LOGIN.get().isShippop">
                            <b-button variant="primary" block @click="updateStatusPaidInvoice()" :disabled="disabledBtn || !modalPay.datePaid">
                                <i class="fas fa-circle-notch fa-spin" v-if="modalPay.isLoading"></i> ชำระเงิน
                            </b-button>
                        </template>
                        <template v-else>
                            <b-button variant="primary" block @click="processPayment()" :disabled="disabledBtn">
                                <i class="fas fa-circle-notch fa-spin" v-if="modalPay.isLoading"></i>
                                {{ ( checkWalletAvailableBalance ) ? 'เติมเงิน' : 'ชำระเงิน' }}
                            </b-button>
                        </template>
                    </div>
                </div>
            </card>
        </b-modal>
        <ModalPaymentWallet ref="payment" :paymentWallet="paymentWallet" @topupSuccess="topupSuccess()"/>
    </div>
</template>
<script>
import moment from 'moment'
import ModalPaymentWallet from '@/components/Modals/ModalPaymentWallet'
import { fetchWalletBanlancesToLocalStorage, walletTopup } from "@/axios/walletPayment.js"
import { payInvoice, updateStatueInvoice } from '@/axios/invoice'
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    name: "ModalConfirmPayInvoice" ,
    props: {
        modalPay: Object,
    },
    components:{
        ModalPaymentWallet
    },
    data(){
        return{
            statePaymant: '',
            paymentWallet:{
                show: false,
                urlPayment: '',
            },
            maxDate: moment().format("YYYY-MM-DD[T]HH:mm")
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    methods: {
        processPayment(){
            this.modalPay.isLoading = true;

            if( this.checkWalletAvailableBalance ){
                let credit = ( this.modalPay.type == 'FULL' ) ? this.modalPay.invoice.total : this.modalPay.invoice.total_net_price
                credit = Number(credit - this.$WALLET.available_balance);
                // credit = Number(this.$options.filters.numFormat(credit - this.$WALLET.available_balance,'0,0.00'))
                walletTopup( credit ).then( response => {
                    this.paymentWallet.urlPayment = response
                    this.paymentWallet.show = true
                    this.modalPay.isLoading = false;
                }).catch( error => {
                    this.modalPay.isLoading = false;
                    showErrorModal( error );
                })
            }else{
                this.payment()
            }
        },
        payment(){
            let isWHT = ( this.modalPay.type == 'FULL' ) ? false: true;
            this.modalPay.isLoading = true;
            payInvoice( this.modalPay.invoice.id , isWHT ).then( () => {
                this.updateWallet()
                showSuccessModal("ชำระเงินสำเร็จ")
                this.success()
            }).catch( error => {
                this.modalPay.isLoading = false;
                showErrorModal( error );
            })
        },
        topupSuccess(state){
            this.statePaymant = state
            if( this.statePaymant == 'CONFIRM' ){
                showSuccessModal('เติมเครดิตสำเร็จแล้ว')
            }else{
                showSuccessModal('รอดำเนินการ')
            }
            this.updateWallet()
            this.paymentWallet.show = false
        },
        updateWallet(){
            fetchWalletBanlancesToLocalStorage().then( res => {
                this.$WALLET.balance           = res.balance
                this.$WALLET.peg_balance       = res.peg_balance
                this.$WALLET.available_balance = res.available_balance
            })
        },
        updateStatusPaidInvoice(){
            let isWHT = ( this.modalPay.type == 'FULL' ) ? false: true;
            this.modalPay.isLoading = true;
            updateStatueInvoice( this.modalPay.invoice.id , "paid" , isWHT , this.modalPay.datePaid  ).then( () => {
                showSuccessModal("อัพเดทสถานะสำเร็จ")
                this.success()
            }).catch( error => {
                showErrorModal( error )
                this.modalPay.isLoading = false;
            })
        },
        success(){
            this.modalPay.isLoading = false;
            this.modalPay.show = false;
            this.$emit('getReport')
        },
        closeModal(){
            this.modalPay.show = false
            this.modalPay.invoice = [];
            this.modalPay.type = null
            this.modalPay.isLoading = false;
            this.modalPay.datePaid = null
        },
    },
    computed: {
        typePay(){
            return [
                { key:'FULL', name:'ชำระเต็มจำนวน' },
                { key:'VAT_WHT', name:'ชำระแบบหักภาษี ณ ที่จ่าย' }
            ]
        },
        checkWalletAvailableBalance(){
            return ( this.modalPay.type == 'FULL' )
                    ? this.$WALLET.available_balance < this.modalPay.invoice.total
                    : this.$WALLET.available_balance < this.modalPay.invoice.total_net_price
        },
        disabledBtn(){
            return this.modalPay.isLoading || !this.modalPay.type
        }
    }
}
</script>
